import ButtonScaleViewWithText, {
  Opts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import { startInstallNativeSequence } from './native.sequence';
import { Feature } from 'src/replicant/analytics';
import { guessInstalledNativeAppPlatform } from './native.util';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';

const style: Omit<Opts, 'tracking'> = {
  x: 525,
  y: 250,
  image: 'assets/native/btn_nativeapp_2a.png',
  width: 188,
  height: 224,
  pressedOffsetY: 5,
  textColor: '#b68351',
  fontSize: 22,
  font: 'Body',
  labelPaddingX: 4,
  labelPaddingY: 0,
  labelHeight: 60,
  labelOffsetY: 138,
  wordWrap: true,
};

export default class NativeAppPromoButton extends ButtonScaleViewWithText {
  constructor(opts: Omit<Opts, 'tracking'>) {
    super({
      ...style,
      ...opts,
      localeText: () => i18n('native.install.button.label'),
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.PROMO_BUTTON,
      },
    });
  }

  async onClick() {
    if (guessInstalledNativeAppPlatform() === null) {
      return startInstallNativeSequence('home_icon');
    }

    await openPopupPromise('popupLoginCrossplay', { origin: 'home_icon' });
  }
}
